import React, { useMemo } from 'react';
import '../../styles/festive.css';

const COLORS = ['#e5484d', '#f2b632', '#30a46c', '#6e8cf5', '#f76b15'];

/**
 * A string of twinkling bulbs hanging from a wire with `swags` loops that dip `depth` px.
 * Decorative only; position it with `className`.
 */
const FairyLights = ({ count = 10, swags = 4, depth = 10, className = '' }) => {
  const { wire, bulbs } = useMemo(() => {
    // Each loop is a quadratic curve; its control point sits 2 × depth below the ends, so the
    // lowest point of the wire is `depth` below them.
    const loop = 100 / swags;
    const path = ['M0 4', ...Array.from({ length: swags }, (_, i) => `Q ${(i + 0.5) * loop} ${4 + 2 * depth} ${(i + 1) * loop} 4`)].join(' ');
    const hung = Array.from({ length: count }, (_, i) => {
      const x = ((i + 0.5) / count) * 100;
      const t = (x / loop) % 1;
      return {
        x,
        y: 4 + 4 * t * (1 - t) * depth,
        color: COLORS[i % COLORS.length],
        delay: -((i * 0.37) % 2.4),
        tilt: Math.round((1 - 2 * t) * -18),
      };
    });
    return { wire: path, bulbs: hung };
  }, [count, swags, depth]);

  return (
    <div className={`fairy-lights ${className}`} style={{ height: depth + 22 }} aria-hidden="true">
      <svg viewBox={`0 0 100 ${depth + 22}`} preserveAspectRatio="none">
        <path d={wire} vectorEffect="non-scaling-stroke" />
      </svg>
      {bulbs.map((b, i) => (
        <span
          key={i}
          className="fairy-lights__bulb"
          style={{
            left: `${b.x}%`,
            top: b.y,
            background: b.color,
            boxShadow: `0 0 10px 2px ${b.color}`,
            animationDelay: `${b.delay}s`,
            transform: `rotate(${b.tilt}deg)`,
          }}
        />
      ))}
    </div>
  );
};

export default FairyLights;
